import { RoutePermittedRole } from 'constants/AppConst';
import { ROUTE_STRING } from 'constants/RouteString';
import AllowedAccess from '@tenant/core/AppPermission/AllowedAccess';
import { AuthorizePermission } from '@tenant/utility/constants/authorizePermission';
import List from './List';

// Portion A (developer-portal-audit-read-ui) — gated on AUDIT_READ; a caller without it sees
// Error403 at the route level (AC-9), never a blank/broken page. Unauthenticated (AC-8) is
// handled globally by the jwtAxios interceptor (MSAL silent refresh + retry) — no per-screen
// UI needed here.
export const auditLogRoutes = [
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.AUDIT_LOG.LIST],
    element: (
      <AllowedAccess isPageFailed permissionIds={[AuthorizePermission.AUDIT_READ]}>
        <List />
      </AllowedAccess>
    ),
  },
];
